itsoftApp.createModule("insertUtekaSlider", ["utekaInit"], function () {
    var module = this;
    var insertUtekaSlider = function () {
        const widget = document.querySelector(".js-uteka-widget-slider");
        if (widget) {
            const attr = widget.getAttribute('data-products-id');
            const idsString = attr.replaceAll(' ', '');
            const idsArr = idsString.split(',');
            window.uteka.loadWidgetPre(widget, {
                productId: idsArr[0],
                productIds: idsArr
            })
        }
    };

    module.callback = insertUtekaSlider
});